import type { FC } from 'react';
import { Route } from 'react-router-dom';
import { useStorageServiceRoot } from 'src/apis/storage/use-storage-service-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { StorageOfferCreate } from 'src/pages/storage/offers-new/create';
import { StorageOffersOverviewNew } from 'src/pages/storage/offers-new/overview';

export const StorageOffersNewRoot: FC = () => {
  const storageServiceRoot = useStorageServiceRoot();

  if (!storageServiceRoot.response) {
    return <PageSpinner />;
  }

  return (
    <RootRoutes>
      <Route
        path="/storage/offers-new"
        element={<StorageOffersOverviewNew />}
      />
      <Route
        path="/storage/offers-new/create"
        element={<StorageOfferCreate storageServiceRoot={storageServiceRoot} />}
      />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
